import React from 'react';
import {
  SideNav,
  NavItem,
  NavText,
} from '@app/modules/transaction-form/transactions-form-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

type NavigationProps = {
  title: string;
  active?: boolean;
  onClick?: (e: any) => void;
  identifier: string;
};

const TaskIconStyles = {
  height: 16,
  width: 16,
  color: '#CCD1DA',
};
const ActiveTaskIconStyles = {
  height: 16,
  width: 16,
  color: '#DC3C7E',
};

const TransactionNav = ({
  title,
  active,
  onClick,
  identifier,
}: NavigationProps) => {
  return (
    <NavItem>
      <NavText active={active} onClick={onClick} id={identifier}>
        {title}
      </NavText>
      <FontAwesomeIcon
        icon={faCheckCircle}
        style={active ? ActiveTaskIconStyles : TaskIconStyles}
      />
    </NavItem>
  );
};

type DetailSection = {
  id: string;
  title: string;
};
const sections: DetailSection[] = [
  { id: 'propertyNav', title: 'Property Information' },
  { id: 'documentNav', title: 'Documents' },
  { id: 'involvedNav', title: 'Who is Involved?' },
  { id: 'checklistNav', title: 'Assignment Checklist' },
  { id: 'paymentDueNav', title: 'Payment Due' },
];

type Props = {
  userInfo: any;
};
export default function TransactionDetailSidenav({ userInfo }: Props) {
  const [activeSection, setActivrSection] = React.useState('propertyNav');
  const onClick = (event: any) => {
    const sectionId = event.target.id;
    setActivrSection(sectionId);
    const sectionContainerId = sectionId.replace('Nav', 'Details');
    const sectionElement = document.getElementById(sectionContainerId);
    if (sectionElement !== null) {
      sectionElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <SideNav>
        {sections.map((section: DetailSection, i: number) => (
          <TransactionNav
            title={section.title}
            key={i}
            active={activeSection === section.id}
            onClick={onClick}
            identifier={section.id}
          />
        ))}
      </SideNav>
    </>
  );
}
